/** G8: `/voice` (hands-free voice mode) and You › Research (the user's research library). */
import { Link } from '@tanstack/react-router'
import { AudioLines } from 'lucide-react'
import { ResearchLibrary } from '../components/research/ResearchLibrary.js'
import { VoiceMode } from '../components/voice/VoiceMode.js'
import { Section } from './you/shared.js'

export function VoicePage() {
  return <VoiceMode />
}

export function ResearchSection() {
  return (
    <>
      <Section
        id="research"
        title="Research library"
        action={
          <Link to="/voice" className="inline-flex items-center gap-1 text-[14px] text-accent-text">
            <AudioLines size={14} aria-hidden="true" /> Voice mode
          </Link>
        }
      >
        <p className="m-0 px-4 text-[14px] text-text-2">
          Research you keep across projects. Project research lives in each project’s Research tab.
          Everything here is end-to-end encrypted.
        </p>
        <ResearchLibrary scope="user" />
      </Section>
      <Section id="research-all" title="All research">
        <ResearchLibrary />
      </Section>
    </>
  )
}
